import { GLOSSARY } from "../data/glossary";

// Repère les termes du glossaire présents dans un texte donné.
const NORM = (s) =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const INDEX = GLOSSARY.map((g) => {
  // on éclate "TOS / ROS (SWR)" ou "Hartley / Colpitts" en variantes
  const base = g.term.replace(/\(.*?\)/g, "");
  const variants = base
    .split("/")
    .map((v) => v.trim())
    .filter((v) => v.length >= 3);
  return { g, variants: variants.map(NORM) };
});

export function findGlossaryTerms(text, max = 3) {
  const t = NORM(text || "");
  const found = [];
  const seen = new Set();
  for (const { g, variants } of INDEX) {
    if (seen.has(g.term)) continue;
    if (variants.some((v) => t.includes(v))) {
      found.push(g);
      seen.add(g.term);
      if (found.length >= max) break;
    }
  }
  return found;
}
